const videoList = () => import("@/pages/video/list/index.vue");
const videoForm = () => import("@/pages/video/list/form.vue");
const videoDetail = () => import("@/pages/video/list/detail.vue");

export default [
    {
        path: "/video/list",
        component: videoList,
        meta: [
            {
                name: "视频管理",
                activeRoute: "/video/manage",
            },
            {
                name: "视频列表",
                activeRoute: "/video/list",
            },
        ],
    },
    {
        path: "/video/list/form",
        component: videoForm,
        meta: [
            {
                name: "视频管理",
                activeRoute: "/video/manage",
            },
            {
                name: "视频列表",
                url: "/video/list",
            },
            {
                name: "新增/编辑",
                activeRoute: "/video/list",
            },
        ],
    },
    {
        path: "/video/list/detail",
        component: videoDetail,
        meta: [
            {
                name: "视频管理",
                activeRoute: "/video/manage",
            },
            {
                name: "视频列表",
                url: "/video/list",
            },
            {
                name: "视频详情",
                activeRoute: "/video/list",
            },
        ],
    },
];
